import { constants } from '../../constants';

const { DTT_GATE_FLAG_KEY } = constants;

export interface DataLayerProps {
  data: indexType[];
  mvpOffersData: string;
}

export interface indexType {
  [key: string]: string | number;
}

export interface elmType {
  key: string;
  value: string;
}

export interface KeysRequest {
  keys:
    | 'accept-language'
    | 'user-agent'
    | 'x-request-id'
    | 'x-service-id'
    | 'x-host'
    | 'x-forwarded-host'
    | 'x-lite-site'
    | 'x-request-host'
    | 'sec-fetch-user'
    | 'x-forwarded-for'
    | 'x-schema'
    | 'sec-fetch-mode'
    | 'x-forwarded-port'
    | 'sec-fetch-site'
    | 'sec-fetch-dest'
    | 'x-forwarded-proto'
    | 'x-xm-site-id'
    | 'x-request-uri'
    | 'referer'
    | 'forwarded'
    | 'messageid'
    | 'x-akamai-edgescape'
    | 'x-akamai-device-characteristics'
    | 'x-client-ip'
    | 'x-akamai-config-log-detail'
    | 'akamai-origin-hop'
    | 'digitalserviceswitch';
}

export interface OptionalRequestIds {
  'accept-language'?: string;
  localekey?: string;
  sitename?: string;
  dtt?: string;
  nrp?: string;
  bauBook?: string;
  'user-agent'?: string;
  'x-request-id': string;
  'x-service-id'?: string;
  'x-forwarded-host'?: string;
  'x-host'?: string;
  'x-xm-site-id'?: string;
  'x-lite-site'?: string;
  'x-request-uri'?: string;
  'x-request-host'?: string;
  'sec-fetch-user'?: string;
  'x-forwarded-for'?: string;
  'x-schema'?: string;
  'sec-fetch-mode'?: string;
  'x-forwarded-port'?: string;
  'sec-fetch-site'?: string;
  'sec-fetch-dest'?: string;
  'x-forwarded-proto'?: string;
  'x-akamai-edgescape'?: string;
  'x-akamai-device-characteristics'?: string;
  'x-client-ip'?: string;
  'x-akamai-config-log-detail'?: string;
  'akamai-origin-hop'?: string;
  digitalserviceswitch?: string;
  referer?: string;
  forwarded?: string;
  messageid?: string;
  DATALAYER_ENDPOINT?: string;
  host?: string;
  'res-is-sst-enabled': string;
  'is-bulgari-flow': string; // TODO : Temporary code to run bulgari through mod header.
  'rrdgi-exp-frag': string; // TODO : Temporary code to run no pwd hybrid page through mod header.
  'rlm-exp-frag': string; // TODO : Temporary code to run RLM 2.0 page through mod header.
  'is-remote-spa': string; // TODO : Temporary code to run remote spa through mod header.
  'secure-fields-enabled': string; // TODO : Temporary code to run secure fields payment through mod header.
  'r0-checkout': string; // TODO : Temporary code to run R0 checkout page through mod header.
  'show-ngsf': string; // TODO : Temporary code to run next gen search form through mod header.
  [DTT_GATE_FLAG_KEY]: string;
}

export interface DefiniteRequestIds {
  sessionid: string;
  'mi-play-path': string;
  authorization: string;
  env_platform: string;
  mi_site: string;
  mi_visitor: string;
  remembermeflag: boolean;
  remembermeuserid: string;
  remembermealternateid: string;
  useridtoken: string;
  'query-params': string;
  cookie: string;
  updatedsearchtype: string;
  authstatetoken: string;
  'device-characteristics': string;
}

export interface SessionDataProps {
  cacheData: {
    data: {
      AriesReservation: {
        uxlMigrationStatus?: string;
        propertyId?: string;
      };
      AriesSearch: {
        searchCriteria: {
          availabilityRequestVO: {
            reslink?: boolean;
            groupRateUnavailable?: boolean;
          };
        };
      };
    };
  };
}

export interface RequestProps extends DefiniteRequestIds, OptionalRequestIds {}
